import React from 'react';
import { backendApi } from '../api/backendApi';
import { useQuery } from '@tanstack/react-query';
import { CalendarCheck } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';
import { Badge } from '../Components/ui/badge';

const format = (date, formatStr) => {
  const d = new Date(date);
  if (formatStr === 'MMM dd, yyyy') {
    return d.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  }
  return d.toLocaleDateString();
};

export default function InterviewSchedules() {
  const { data: interviews = [] } = useQuery({
    queryKey: ['interviews'],
    queryFn: () => backendApi.entities.Interview.list('-interview_date', 100),
    initialData: []
  });

  const scheduledInterviews = interviews.filter(i => i.status === 'Scheduled');

  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-lg">
            <CalendarCheck className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Interview Schedules</h1>
            <p className="text-sm text-gray-500">View and manage scheduled interviews</p>
          </div>
        </div>
      </div>
      
      <div className="grid gap-4">
        {scheduledInterviews.length > 0 ? (
          scheduledInterviews.map(interview => (
            <Card key={interview.id} className="shadow-sm">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{interview.applicant_name}</h3>
                    <p className="text-sm text-gray-600">{interview.job_title}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium">{interview.interview_date && format(new Date(interview.interview_date), 'MMM dd, yyyy')}</p>
                    <Badge className="bg-blue-100 text-blue-800 mt-1">{interview.interview_type}</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        ) : (
          <Card className="shadow-sm">
            <CardContent className="text-center py-12">
              <CalendarCheck className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">No scheduled interviews</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}